"use client";

import { c as _c } from "react/compiler-runtime";
import type { Currency } from "@/features/currencies/types";
import { formatTokenSymbol } from "@/lib/asset-naming";
import { Coin, PickRow, PickerView } from "@/features/wallet/v2/dialogs/kit";

/** The chosen currency as a row that opens the network's list in place (never a native select). */
export function CurrencyRow(t0) {
  const $ = _c(19);
  const {
    currencies,
    value,
    reason,
    onOpen,
    isFa
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== currencies || $[1] !== isFa || $[2] !== reason || $[3] !== value) {
    let t5;
    if ($[9] !== value) {
      t5 = x => String(x.id) === value;
      $[9] = value;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    const c = currencies.find(t5);
    T0 = PickRow;
    t1 = isFa ? "\u0627\u0631\u0632" : "Currency";
    t2 = <Coin src={c?.image} />;
    t3 = c ? c.name : isFa ? "\u0627\u0646\u062A\u062E\u0627\u0628 \u0627\u0631\u0632" : "Select a currency";
    t4 = c ? formatTokenSymbol(c.symbol) : reason ?? undefined;
    $[0] = currencies;
    $[1] = isFa;
    $[2] = reason;
    $[3] = value;
    $[4] = T0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    T0 = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  const t5 = currencies.length === 0;
  let t6;
  if ($[11] !== T0 || $[12] !== onOpen || $[13] !== t1 || $[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5) {
    t6 = <T0 label={t1} icon={t2} title={t3} sub={t4} onClick={onOpen} disabled={t5} />;
    $[11] = T0;
    $[12] = onOpen;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}

/** The network's currencies, as the wallet dialogs list tokens — the chosen one ticked. */
export function CurrencyList(t0) {
  const $ = _c(14);
  const {
    currencies,
    value,
    onPick,
    onBack,
    isFa
  } = t0;
  const t1 = isFa ? "\u0627\u0646\u062A\u062E\u0627\u0628 \u0627\u0631\u0632" : "Select a currency";
  const t2 = isFa ? "\u0628\u0627\u0632\u06AF\u0634\u062A" : "Back";
  const t3 = isFa ? "\u0627\u0631\u0632\u06CC \u0628\u0631\u0627\u06CC \u0627\u06CC\u0646 \u0634\u0628\u06A9\u0647 \u067E\u06CC\u062F\u0627 \u0646\u0634\u062F." : "No currency was found for this network.";
  let t4;
  if ($[0] !== currencies) {
    t4 = currencies.map(_temp);
    $[0] = currencies;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== onBack || $[3] !== onPick) {
    t5 = id => {
      onPick(id);
      onBack();
    };
    $[2] = onBack;
    $[3] = onPick;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== isFa || $[6] !== onBack || $[7] !== t1 || $[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== value) {
    t6 = <PickerView isFa={isFa} title={t1} backLabel={t2} value={value} empty={t3} items={t4} onPick={t5} onBack={onBack} />;
    $[5] = isFa;
    $[6] = onBack;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = value;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
function _temp(c) {
  return {
    key: String(c.id),
    icon: <Coin src={c.image} />,
    title: c.name,
    sub: formatTokenSymbol(c.symbol),
    search: `${c.name} ${c.symbol}`
  };
}